export default __webpack_public_path__ + "static/banner-two-shape12-951eda528317d196fd5b53069925d68d.png";